import moment from "moment";

export default function getDateRange(firstDate, lastDate, type = "day") {
  let format = "";
  switch (type) {
    case "day":
      format = `YYYY-MM-DD`;
      break;
    case "week":
      format = `YY年第w[週]`;
      break;
    case "month":
      format = `YY年M月`;
      break;
    case "quarter":
      format = `YY年[Q]Q`;
      break;
    case "year":
      format = `YYYY`;
      break;
    default:
      break;
  }
  if (
    moment(firstDate, "YYYY-MM-DD").isSame(
      moment(lastDate, "YYYY-MM-DD"),
      "day"
    )
  )
    return [moment(lastDate).format(format)];
  let date = firstDate;
  const dates = [moment(date).format(format)];
  do {
    date = moment(date).add(1, "day");
    if (!dates.includes(date.format(format))) dates.push(date.format(format));
  } while (moment(date).isBefore(lastDate));
  return dates;
}
